import hero from './assets/aerial_platform_bw_cropped.jpg';
import heroWebp from './assets/aerial_platform_bw_cropped.webp';
import aerial from './assets/aerial-platform-basket.jpg';
import aerialWebp from './assets/aerial-platform-basket.webp';
import ladder from './assets/ground-ladder-test.jpg';
import ladderWebp from './assets/ground-ladder-test.webp';
import pump from './assets/pump-panel.jpg';
import pumpWebp from './assets/pump-panel.webp';
import ndt from './assets/ndt-welds.jpg';
import ndtWebp from './assets/ndt-welds.webp';
import aerialWide from './assets/aerial-test-2.jpg';
import aerialWideWebp from './assets/aerial-test-2.webp';
import pumpDraft from './assets/hero-pump-testing.jpg';
import pumpDraftWebp from './assets/hero-pump-testing.webp';
import commandTruck from './assets/aerial-command-truck.jpg';
import commandTruckWebp from './assets/aerial-command-truck.webp';
import truckRear from './assets/truck_rear_bw_cropped.jpeg';
import truckRearWebp from './assets/truck_rear_bw_cropped.webp';
import logo from './assets/logo.png';
import logoWebp from './assets/logo.webp';

export const PHOTOS = {
  hero: {
    src: hero,
    webp: heroWebp,
    width: 3950,
    height: 1471,
    alt: 'Aerial ladder extended from a fire apparatus',
  },
  aerial: {
    src: aerial,
    webp: aerialWebp,
    width: 1440,
    height: 1920,
    alt: 'Aerial platform basket raised beside a fire station during aerial device testing',
  },
  ladder: {
    src: ladder,
    webp: ladderWebp,
    width: 1512,
    height: 650,
    alt: 'Ground ladder on a test rack with a gauge during annual ladder testing',
  },
  pump: {
    src: pump,
    webp: pumpWebp,
    width: 1440,
    height: 1920,
    alt: 'Fire apparatus pump panel with gauges and valves during pump testing',
  },
  ndt: {
    src: ndt,
    webp: ndtWebp,
    width: 1440,
    height: 1920,
    alt: 'Structural weld marked with layout lines for nondestructive testing',
  },
  aerialWide: {
    src: aerialWide,
    webp: aerialWideWebp,
    width: 1920,
    height: 1440,
    alt: 'Aerial ladder extended over a fire station during on-site aerial device testing',
  },
  pumpDraft: {
    src: pumpDraft,
    webp: pumpDraftWebp,
    width: 1920,
    height: 933,
    alt: 'Technician checking a flow meter and hose line during an annual fire pump test',
  },
  commandTruck: {
    src: commandTruck,
    webp: commandTruckWebp,
    width: 1440,
    height: 1920,
    alt: 'Command Testing truck parked in front of a raised aerial ladder during on-site testing',
  },
  truckRear: {
    src: truckRear,
    webp: truckRearWebp,
    width: 879,
    height: 893,
    alt: 'Rear of a fire engine tested by Command Testing',
  },
  logo: {
    src: logo,
    webp: logoWebp,
    width: 185,
    height: 227,
    alt: 'Command Testing logo',
  },
};
